import classes from "./About.module.css";
import { useEffect } from "react";
import DUMMY_DATA from "../../dummyData.json";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

// import required modules
import { Pagination, Navigation } from "swiper";

const About = () => {
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--swiper-theme-color",
      "#4a5568"
    );
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <h2 className={classes.about__title}>
        <span className={classes.highlight}>關於巧漾</span>
      </h2>

      <Swiper
        slidesPerView={1}
        loop={true}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Pagination, Navigation]}
        className={classes.mySwiper}
      >
        {DUMMY_DATA.map((data) => {
          return (
            <SwiperSlide key={data.id}>
              <div className={classes.carousel__img}>
                <img src={data.img} />
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
      <div className={classes.about__text}>
        <p>
          創新、優質、感動、信賴
          <br />
          是巧漾國際一路走來從不放棄的企業經營原則。
        </p>
        <p>我們一直深信，唯有不斷創新與用心，方能獲得客戶的肯定。</p>
        <p>
          若您有各方面的禮品、贈品等相關採購需求，竭誠的歡迎您與我們聯繫，
          我們將會為您量身打造專屬於您企業形象以及符合您活動主軸的相關贈品規劃提案!
        </p>
      </div>
    </>
  );
};

export default About;
